// eslint-disable-next-line no-restricted-imports
import { request as requestOrg } from "libs/openapi";
import { ApiPath, HttpMethod } from "libs/openapi/schema-utils";

// /admin/以下のうち、/admin/api/ではないもの
type AdminEndpoints = Extract<ApiPath, `/admin/${string}`> &
  Exclude<ApiPath, `/admin/api/${string}`>;

export const request = <Method extends HttpMethod, Path extends AdminEndpoints>(
  ...params: Parameters<typeof requestOrg<Method, Path>>
) => requestOrg<Method, Path>(...params);
